// removed by extract-text-webpack-plugin
module.exports = {"mainWrap":"qempo_HelpTicket_mainWrap-2BqppHi","formWrap":"qempo_HelpTicket_formWrap-3mxnQ_o","title":"qempo_HelpTicket_title-1E2zfoj","loading":"qempo_HelpTicket_loading-mU9HTBk","modalWrap":"qempo_HelpTicket_modalWrap-3hbe8pb","modalTitle":"qempo_HelpTicket_modalTitle-4BEWYvp","modalContent":"qempo_HelpTicket_modalContent-IoZ-35P","modalButton":"qempo_HelpTicket_modalButton-2MQSTw4","alertWrap":"qempo_HelpTicket_alertWrap-3uf7t7A"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/help-ticket/components/HelpTicket.scss
// module id = 2192
// module chunks = 0